var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M 0 7 L 0 9.9121094 C 6.708 15.709109 20.532062 27.656578 21.664062 28.642578 C 23.074063 29.869578 24.466 30.001953 25 30.001953 C 25.534 30.001953 26.926937 29.870531 28.335938 28.644531 C 29.425937 27.695531 42.784 16.033422 50 9.7324219 L 50 7 L 0 7 z M 50 12.382812 C 42.588 18.853813 30.673484 29.255437 29.646484 30.148438 C 27.729484 31.817438 25.758 31.998047 25 31.998047 C 24.242 31.998047 22.270516 31.817484 20.353516 30.146484 C 19.290516 29.222484 7.044 18.638781 0 12.550781 L 0 43 L 50 43 L 50 12.382812 z"}));
}

Envelope.defaultProps = {"fill":"#FFFFFF","viewBox":"0 0 50 50","width":"50px","height":"50px"};

module.exports = Envelope;

Envelope.default = Envelope;
